export default {
	SET_LOADING_STATE: (state, status) => {
		state.isLoading = status
	},
	// 获取年级科目
	GET_SUBJECT_DATA(state, res) {


		
		let grade = []
		let subject = []
		let subjectToLabel = {}

		try {
			const initGrade = res.data

			if (!initGrade.length) {
				throw new Error('no data');
			}

			initGrade.forEach((i, index) => {
				// 初四对应初三会导致v-model只能渲染第一个label为初三的项目，临时修改，后面待完善
				if (i.extendLabel == "初四" && i.label == "初三") {
					i.label = "初四"
				}
				grade.push([i.label, i.extendLabel])
				let childsubject = []
				subject.push(childsubject)
				res.data[index].children.forEach(item => {
          if(!/陪练/.test(item.label)) {
            childsubject.push([item.label, item.label])
          }
					// childsubject.push([item.label, item.extendLabel])
					if (item.label !== item.extendLabel && !subjectToLabel[item.label]) {
						subjectToLabel[item.label] = item.extendLabel
					}
				})
			})

			state.subjectGrade = grade
			state.subjectData = subject
			state.subjectToLabel = subjectToLabel
		} catch (e) {

			console.log("========================================")
			const {
				gradeData,
				subjectData,
				subjectToLabelData
			} = require('@/assets/js/prepareData')

			state.subjectGrade = gradeData
			state.subjectData = subjectData
			state.subjectToLabel = subjectToLabelData
		}
	}
}
